import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'
import _ from 'lodash'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Row, Col, Alert, Modal, Button, Form, Input, Checkbox, message } from 'antd'
import { graphql, withApollo } from 'react-apollo'
import gql from 'graphql-tag'

class Index extends Component {

	constructor(props) {
		super(props)

		this.state = {
			isSaving: false,
			confirmDirty: false,
		}

		this.handleOnSubmit = this.handleOnSubmit.bind(this)
	}

	handleOnSubmit(e) {
		e.preventDefault()
		const { form, AuthStore, savePassword, user_uid, onCancel } = this.props

		form.validateFields((err, values) => {
			if (err) {
				AuthStore.setError('Please Fill All Fields')
				return false
			}
			values = Object.assign({}, values, { user_uid })
			this.setState({ isSaving: true }, () => {
				savePassword(values)
					.then((response) => {
						message.success('Password successfully updated.')
						this.setState({ isSaving: false }, () => {
							AuthStore.setIsPasswordChanged(true)
							onCancel()
						})
					})
					.catch(err => {
						console.log('error saving new password', err)
						this.setState({ isSaving: false })
						message.error(err.message.replace('GraphQL error:',''))
						onCancel()
					})
			})
		})
	}
	
	handleConfirmBlur = (e) => {
    	const value = e.target.value
    	this.setState({ confirmDirty: this.state.confirmDirty || !!value })
	}
    
    compareToFirstPassword = (rule, value, callback) => {
    	const form = this.props.form
    	if (value && value !== form.getFieldValue('new_password')) {
    		callback('Two passwords that you enter is inconsistent!')
    	} else if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
    		callback('only white space detected.')
    	} else {
    		callback()
    	}
    }

    validateToNextPassword = (rule, value, callback) => {
    	const form = this.props.form
    	if (value && this.state.confirmDirty) {
    		form.validateFields(['confirm_passowrd'], { force: true })
    	} else if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
    		callback('only white space detected.')
    	}
    	callback()
    }

    render() {
    	const { isSaving } = this.state
    	const { form, onCancel, visible } = this.props
    	const { getFieldDecorator } = form
	
    	return (
    		<Modal
    			title='Change Account Password'
    			width='40%'
    			visible={visible}
    			onCancel={onCancel}
    			onOk={this.handleOnSubmit}
    			okText='Update'
    			confirmLoading={isSaving}
    			maskClosable={!isSaving}
    			destroyOnClose
    		>
    			<Form onSubmit={this.handleOnSubmit}>
    				<Row className='form-email'>
    					<Form.Item label='Current Password'>
    						{ getFieldDecorator('old_password', {
    							rules: [{
    								required: true,
    								message: 'This field is required.'
    							}, {
    								validator: this.validateToNextPassword
    							}]
    						})
    						(
    							<Input.Password maxLength={32} placeholder='Old Password here'/>
    						)}
    					</Form.Item>
    				</Row>
    				<Row className='form-email'>
    					<Form.Item label='New Password'>
    						{ getFieldDecorator('new_password', {
    							rules: [{
    								required: true,
    								message: 'This field is required.'
    							}, {
    								validator: this.validateToNextPassword
    							}]
    						})
    						(
    							<Input.Password maxLength={32} placeholder='Password here'/>
    						)}
    					</Form.Item>
    				</Row>
    				<Row className='form-email'>
    					<Form.Item label='Confirm New Password'>
    						{ getFieldDecorator('confirm_password', {
    							rules: [{
    								required: true,
    								message: 'This field is required.'
    							}, {
    								validator: this.compareToFirstPassword
    							}]
    						})
    						(
    							<Input.Password onBlur={this.handleConfirmBlur} maxLength={32} placeholder='Password here'/>
    						)}
    					</Form.Item>
    				</Row>
    			</Form>
    		</Modal>
    	)
    }
}

const updatePassword = gql`
	mutation changeUserPassword ($input: JSON) {
		changeUserPassword (input: $input)
	}
`

const composed = compose(
	withRouter,
	Form.create({ name: 'changepassword-form' }),
	inject('AuthStore'),
	graphql(updatePassword, {
		props({ mutate }) {
			return {
				savePassword(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['userDetailsByUid']
					})
				}
			}
		}
	}),
	observer,
)

export default composed(Index)
